import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { PermissionsModule } from '../../auth/permissions/permissions.module';
import { ArrayIncludesPipe, SetHasPipe } from '../../shared/helpers/pipes/common/common-pipes.pipe';
import { TrackElementDirective } from '../tracker/track-element.directive';
import { IsPageActivePipe, SidenavComponent } from './sidenav.component';

@NgModule({
  declarations: [SidenavComponent, IsPageActivePipe],
  imports: [
    CommonModule,
    RouterModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    PermissionsModule,
    TranslocoModule,
    ArrayIncludesPipe,
    SetHasPipe,
    TrackElementDirective,
  ],
  exports: [SidenavComponent],
})
export class SidenavModule {}
